module.exports = "/images/vendor/desiigner-svg/svg/social/whatsapp.svg?0e01da8854ed9091db7c797f32e01dad";